import React from 'react';
import { C } from '../constants/theme';
import { Button } from './Button';

export function PageHeader({ title, count, onAdd, addLabel = '+ Add New', actions }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
      <div>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: C.text }}>{title}</h2>
        {count !== undefined && (
          <p style={{ margin: '2px 0 0', fontSize: 13, color: C.textMuted }}>{count} total records</p>
        )}
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        {actions}
        {onAdd && <Button onClick={onAdd}>{addLabel}</Button>}
      </div>
    </div>
  );
}